<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Blog Details" />
            <BlogDetails />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import BlogDetails from '../BlogDetails/BlogDetails'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'BlogDetailsPage',
    components: {
        NavBar,
        PageTitle,
        BlogDetails,
        FooterComp,
    }
}
</script>